/* eslint-disable no-unused-vars */

import { capitalise, formatMoney } from '../../utils/functions';

export function getToolTipHTML(props, colour, average) {
  let htmlSnip = '<div class="toolt-wrap">';
  if (props.SA2_NAME21 !== '') {
    htmlSnip += `<div class="toolt-place">${props.SA2_NAME21}</div>`;
  }
  if (props.STE_NAME21 !== '') {
    htmlSnip += `<div class="toolt-state">${props.STE_NAME21}</div>`;
  }

  if (props.m2022_23 && props.mapVar !== 0) {
    htmlSnip += `<div class="toolt-pop">2022/23 Median income:&nbsp;<span class="emph" style="color:${colour};">${formatMoney(props.m2022_23)}</span></div>`;
    htmlSnip += `<div class="toolt-pop">2022/23 Mean income:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span class="emph" style="color:${colour};">${formatMoney(props.mean2022_23)}</span></div>`;
    htmlSnip += '<div class="toolt-seperator"></div>';
  }

  if (props.m2022_23 && props.mapVar !== 0) {
    htmlSnip += `<div class="toolt-pop">${capitalise(average)} income</div>`;
    htmlSnip +=
      '<svg class="popup-d3-svg" style="margin: 0 auto; display: block;"><g class="chart"><g class="line-chart"></g><g class="dots-chart"></g><g class="x-axis"></g><g class="y-axis"></g><g class="latest"></g></g></svg>';
  } else {
    htmlSnip += '<p>Data unavailable or sample size too small.</p>';
  }

  htmlSnip += '</div>';
  return htmlSnip;
}
